<template>
  <div class="body">
    <template v-if="hallOfFame.length > 0">
      <div class="section-title">Hall of Fame</div>
      <div class="hall-of-fame">
        <div v-for="data in hallOfFame" :key="data.nftId">
          <bunicorn-nft-card
            v-if="getNftNameFromAddress(data.nftContract) === 'Bunicorn'"
            :nftData="formatNftCardData(data)"
          />
          <trainer-nft-card
            v-if="getNftNameFromAddress(data.nftContract) === 'Trainer'"
            :nftData="formatNftCardData(data)"
          />
        </div>
      </div>
    </template>
    <a href="https://bunicorn.game/pvp-arena-list" target="_blank">
      <img
        class="event-image"
        :src="'/bunicorn-game/event-bunicorn-pvp-challenge.png'"
      />
    </a>

    <VueSlickCarousel
      v-bind="settings"
      :style="{
        width: '100%',
        height: 'auto!important'
      }"
      ref="el"
    >
      <template #prevArrow>
        <div class="custom-arrow">
          <img src="@/assets/icon/left-arrow.svg" />
        </div>
      </template>
      <div>
        <div class="section-title">Featuring from Marketplace</div>
        <div class="section-subtitle">
          <div class="game-name">Bunicorn</div>
          <ExploreMoreButton
            @buttonClick="$router.push({ name: 'market-bunicorn-game' })"
          />
        </div>
        <div class="carousel-slide">
          <div class="featuring">
            <div v-for="data in featuring" :key="data.nftId">
              <bunicorn-nft-card
                v-if="getNftNameFromAddress(data.nftContract) === 'Bunicorn'"
                :nftData="formatNftCardData(data)"
              />
              <trainer-nft-card
                v-if="getNftNameFromAddress(data.nftContract) === 'Trainer'"
                :nftData="formatNftCardData(data)"
              />
            </div>
            <!-- <NftCard
              v-for="data in featuring"
              :key="data.nftId"
              :nft-data="formatNftCardData(data)"
            /> -->
          </div>
        </div>
      </div>
      <!-- <div>
        <div class="section-title">Featuring from Marketplace</div>
        <div class="section-subtitle">
          <div class="game-name">Game B</div>
          <ExploreMoreButton />
        </div>
        <div class="carousel-slide">
          <div class="hall-of-fame">
           <NftCard />
           <NftCard />
           <NftCard />
           <NftCard />
          </div>
        </div>
      </div> -->
      <!-- <div class="carousel-slide">
        <MysteryBoxCard class="mystery-box"/>
      </div> -->
      <template #nextArrow>
        <div class="custom-arrow">
          <img src="@/assets/icon/right-arrow.svg" />
        </div>
      </template>
    </VueSlickCarousel>
  </div>
</template>

<script>
import { getSellMethod } from '@/helpers';
// import NftCard from '@/components/BaseComponents/NftCard.vue';
import BunicornNftCard from '@/components/BunicornGame/BunicornNftCard.vue';
import TrainerNftCard from '@/components/BunicornGame/TrainerNftCard.vue';
import ExploreMoreButton from '@/components/BaseComponents/ExploreMoreButton.vue';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
// import MysteryBoxCard from '@/components/BaseComponents/MysteryBoxCard.vue';
import rf from '@/requests/RequestFactory';
import config from '@/config';
import _ from 'lodash';

export default {
  components: {
    BunicornNftCard,
    TrainerNftCard,
    // NftCard,
    ExploreMoreButton,
    VueSlickCarousel
    //  MysteryBoxCard
  },
  data() {
    return {
      settings: {
        dots: true,
        focusOnSelect: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        touchThreshold: 5,
        arrows: true
      },
      hallOfFame: [],
      featuring: []
    };
  },
  computed: {
    bunicornGameConfig() {
      const projects = config.projects;
      return projects.bunicornGame;
    }
  },
  methods: {
    getSellMethod,
    getNftNameFromAddress(contractAddress) {
      if (!this.bunicornGameConfig || !contractAddress) {
        return '';
      }
      const nftCollection = _.find(
        this.bunicornGameConfig.collections || [],
        collection => {
          return collection.nftContract === contractAddress;
        }
      );
      return nftCollection ? nftCollection.nftName : '';
    },
    formatNftCardData(data) {
      const metaData = data.metaData || {};
      return {
        nftContract: data.nftContract,
        nftId: data.nftId,
        nftImage: metaData.image,
        nftName: metaData.name,
        nftAttributes: metaData.attributes,
        sellMethod: this.getSellMethod(data.sellMethod),
        price: data.minPrice,
        sellerAddress: data.sellerAddress,
        collectionType: 1,
        currencyAddress: data.currency
      };
    }
  },
  async mounted() {
    const res = await rf.getRequest('GameMarketplaceRequest').getHallOfFame();
    this.featuring = await rf
      .getRequest('GameMarketplaceRequest')
      .getFeaturingFromMarketplace(
        config.projects.bunicornGame.collections[1].nftContract
      );
    if (res) {
      this.hallOfFame = res;
    }
  }
};
</script>

<style lang="scss" scoped>
@import './../assets/style/variables.scss';

.body {
  margin: 40px 0;
  font-family: Inter;
  background-color: #fff;
  .section-title {
    font-family: Inter-Bold;
    text-align: center;
    font-size: 32px;
    color: #203a54;
    margin-bottom: 40px;
  }
  .section-subtitle {
    font-family: Inter-SemiBold;
    font-size: 32px;
    color: #203a54;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 30px 30px 30px;
  }
  ::v-deep .slick-next:before,
  .slick-prev:before {
    content: '';
  }
  .custom-arrow {
    width: 88px;
    z-index: 1;
    transform: translate(0, -50%);
    img {
      width: 88px;
      height: 88px;
      object-fit: contain;
    }
  }
  .slick-prev {
    left: -44px;
  }
  .slick-next {
    right: -44px;
  }
  ::v-deep .hall-of-fame {
    display: flex;
    justify-content: space-around;
    max-width: 1200px;
    margin: auto;
  }
  .featuring {
    display: flex;
    overflow-x: auto;
    justify-content: flex-start;
    max-width: 1200px;
    margin: auto;
  }
  .event-image {
    margin: 60px 0;
    width: -webkit-fill-available;
  }
  .mystery-box {
    height: 642px;
    display: flex;
    align-items: center;
  }
}
@media screen and (max-width: $breakpoint-desktop) {
  .body {
    ::v-deep .hall-of-fame {
      justify-content: flex-start;
      overflow-x: auto;
    }
  }
}
</style>
